// =============================================================================
// Local storage helpers — one-time key migration for rebranded persist keys
// =============================================================================

export function migrateLocalStorageKey(nextKey: string, legacyKey: string): void {
  if (typeof window === "undefined") return;
  try {
    if (window.localStorage.getItem(nextKey) != null) return;
    const legacy = window.localStorage.getItem(legacyKey);
    if (legacy == null) return;
    window.localStorage.setItem(nextKey, legacy);
    window.localStorage.removeItem(legacyKey);
  } catch {
    // Ignore quota or privacy-mode errors; app falls back to defaults.
  }
}
